import { VueConstructor } from 'vue';
import VDataTransformer from './v-data-transformer.vue';
import VErrorBoundary from './v-error-boundary';

const ComponentPlugins = {
    install(Vue: VueConstructor) {
        Vue.component(VDataTransformer.name, VDataTransformer);
        Vue.component('VErrorBoundary', VErrorBoundary);

        Vue.prototype.$initialRoleStatus = async function() {
            const userId = this.$store.state['auth'].user.id;
            await this.$store.dispatch('user-options/get', [
                userId,
                { query: {
                    accessable: [
                        'users',
                        'logic-control',
                        'api/service-lists',
                        'api/model-props',
                        'api/api-lists',
                        'bh-survey-options',
                        'bh-survey-option-tree'
                    ]
                } }
            ]);
        };

        Vue.prototype.$accessable = function(lists: string[]) {
            const userId = this.$store.state['auth'].user && this.$store.state['auth'].user.id;
            if(userId) {
                const result = this.$store.getters['user-options/get'](userId);
                if(result && result.accessable) {
                    for(const item of lists) {
                        if(result.accessable.indexOf(item) !== -1) {
                            return true;
                        }
                    }
                }
            }
            return lists.length === 0;
        };
    }
};

export default ComponentPlugins;